<template>
  <div class="home">
    <div class="home__charts">
      <div v-for="({ component, chart, id, name, title }) in charts" class="home__charts__wrapper" :key="id">
        <div class="container" :id="id">
          <div class="row">
            <div class="col my-2">
              <component
                :is="component"
                :chart="chart"
                :social-mode="socialModes[id]"
                :no-footer="noFooters[id]"
                class="home__charts__wrapper__component border" />
            </div>
            <div class="col-12 col-lg-5 home__charts__wrapper__embed my-2" v-if="showEmbeds">
              <b-tabs content-class="mt-2" no-fade>
                <b-tab title="Embed" active>
                  <embed-form
                    :url="chartAbsolutePath(name)"
                    :height="660"
                    no-preview
                    no-title
                    class="overflow-hidden mt-4" />
                  <b-form-checkbox v-model="socialModes[id]" class="mb-2">
                    <span class="font-weight-bold">Social mode</span> <span class="text-muted">(dark background, no footer)</span>
                  </b-form-checkbox>
                  <b-form-checkbox v-model="noFooters[id]">
                    <span class="font-weight-bold">No footer</span>
                  </b-form-checkbox>
                </b-tab>
                <b-tab title="Link">
                  <advanced-link-form
                    pills
                    :forms="['raw', 'rich', 'markdown']"
                    :title="title"
                    :link="chartAbsolutePath(name)" />
                </b-tab>
                <b-tab title="Download">
                  <download-form
                    :chart="chart"
                    :title="title"
                    :social-mode.sync="socialModes[id]"  />
                </b-tab>
                <template #tabs-end>
                  <b-nav-item :href="chartRelativePath(name)" target="_blank" class="ml-auto">
                    <fa icon="external-link-alt" class="mr-1" />
                    <span class="sr-only">
                      In a new window
                    </span>
                  </b-nav-item>
                </template>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find, filter, uniqueId } from 'lodash'
import { routes, ChartRoute } from '../router'

import DownloadForm from '../components/DownloadForm.vue'

export default {
  name: 'Home',
  components: {
    DownloadForm
  },
  data () {
    return {
      noFooters: {},
      socialModes: {}
    }
  },
  methods: {
    chartRelativePath (name) {
      const chart = find(routes, { name })
      const socialMode = !!this.socialModes[chart.id]
      const noFooter = !!this.noFooters[chart.id]
      const query = { socialMode, noFooter }
      const route = this.$router.resolve({ name, query })
      return route.href
    },
    chartAbsolutePath (name) {
      const base = 'https://projects.icij.org'
      return [base, this.chartRelativePath(name)].join('')
    }
  },
  computed: {
    charts () {
      return filter(routes, route => route instanceof ChartRoute)
    },
    nonEmptyCharts () {
      return filter(this.charts, route => !route.isEmpty)
    },
    chartsTsvHeader () {
      return ['title', 'url', 'iframe', 'responsive_iframe'].join('\t')
    },
    chartsTsv () {
      return routes.reduce((rows, route) => {
        if (route.chart && !route.isEmpty) {
          const url = `${this.$config.get('app.url')}/${route.name}`
          const iframe = `<iframe width="100%" height="600" src="${url}" frameborder="0" allowfullscreen></iframe>`
          const script = 'script'
          const chartId = uniqueId(`icij-chart-${route.name}-`)
          const responsiveIframe = `<${script} type="text/javascript" src="https://pym.nprapps.org/pym.v1.min.js"></${script}><div id="${chartId}"></div><${script}>;new pym.Parent("${chartId}", "${url}", {})</${script}>`
          rows.push([route.title, url, iframe, responsiveIframe].join('\t'))
        }
        return rows
      }, [this.chartsTsvHeader]).join('\n')
    },
    showEmbeds () {
      return this.$route.name !== 'Embed'
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  @import '../../node_modules/bootstrap/scss/_mixins.scss';

  .home {

    &__charts {
      background: #f9f9f9;
        
      &__wrapper {

        &:last-of-type .container:after {
          display: none;
        }

        & .container {
          position: relative;
          padding-top: 6rem;
          padding-bottom: 6rem;

          &:after {
            content: "";
            height: 0.2rem;
            margin: 0 $spacer;
            background-color: $primary;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
          }
        }

        &__embed {
          font-size: 0.9rem;

          label, .btn {
            font-size: inherit;
          }

          .tabs .nav-tabs .nav-link.active {
            background: #f9f9f9 !important;
            border-bottom-color: #f9f9f9;
            font-weight: bold;
          }

          .embed-form > .container-fluid {
            padding: 0;
          }
        }
      }
    }
  }
</style>
